import { defineStore } from "pinia";
import { store } from "/@/store";

export const useAppStore = defineStore("app", {
  state: () => ({
    serverTime: null as null | number,
    initServerTime: null as null | number,
  }),
  getters: {},
  actions: {
    async setServerTime(time: number) {
      this.initServerTime = new Date().valueOf();
      this.serverTime = time;
    },
    getServerTime(): number {
      if (!this.initServerTime || !this.serverTime) {
        return new Date().valueOf();
      } else {
        return new Date().valueOf() - this.initServerTime + this.serverTime;
      }
    },
  },
});

export function useAppStoreWithOut() {
  return useAppStore(store);
}
